export const CRM_API_URL = process.env.REACT_APP_CRM_API_URL;
